import DefaultFactory from "/scripts/default/factory";
import TextHero from "/components/text/hero";
import TextIntro from "/components/text/intro";
import TextScramble from "/components/text/scramble";

/*
	Individual page factories follow the same principles as
	the global factory in /public/scripts/index.js but contain
	blocks that should only be checked for on a single page
*/
class TextFactory extends DefaultFactory {
	createBlock(blockName, block) {
		switch (blockName) {
			case "text-hero":
				return new TextHero(block);
			case "text-intro":
				return new TextIntro(block);
			case "text-scramble":
				return new TextScramble(block);
			default:
				return null;
		}
	}
}

new TextFactory();
